import { useRef, useState } from "react";
import { toPng } from "html-to-image";
import { Instagram, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../context/LanguageContext";

const fmt = (v) => (v ? new Date(v).toLocaleDateString("el-GR", { day: "2-digit", month: "long", year: "numeric" }) : "");

export const SuccessCard = ({ cert }) => {
  const { t } = useLang();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const title = cert.course_title || cert.course?.title || "";

  const download = async () => {
    setBusy(true);
    try {
      const dataUrl = await toPng(ref.current, { width: 1080, height: 1080, pixelRatio: 1, cacheBust: true });
      const a = document.createElement("a");
      a.href = dataUrl;
      a.download = `sportscience-${cert.code || "certificate"}.png`;
      a.click();
      toast.success(t("certs.cardReady"));
    } catch {
      toast.error(t("certs.cardError"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        data-testid={`certificate-instagram-${cert.code}`}
        onClick={download}
        disabled={busy}
        className="btn-outline-light !px-5 !py-2.5 text-xs disabled:opacity-60"
      >
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Instagram className="w-4 h-4" />} {t("certs.instagram")}
      </button>

      <div style={{ position: "fixed", left: -20000, top: 0, pointerEvents: "none" }} aria-hidden="true">
        <div
          ref={ref}
          style={{
            width: 1080, height: 1080, background: "#0B1B3A", color: "#fff", padding: 88,
            fontFamily: "'Plus Jakarta Sans', Arial, sans-serif", position: "relative", overflow: "hidden",
            display: "flex", flexDirection: "column", justifyContent: "space-between", boxSizing: "border-box",
          }}
        >
          <div style={{ position: "absolute", right: -160, top: -160, width: 520, height: 520, borderRadius: "50%", background: "#1D4ED8", opacity: 0.9 }} />
          <div style={{ position: "absolute", left: -120, bottom: -200, width: 460, height: 460, borderRadius: "50%", border: "36px solid #1D4ED8", opacity: 0.35 }} />
          <div style={{ position: "relative", fontSize: 22, fontWeight: 800, letterSpacing: 6, textTransform: "uppercase", color: "#93C5FD" }}>
            SportScience Academy
          </div>
          <div style={{ position: "relative" }}>
            <div style={{ display: "inline-block", background: "#fff", color: "#1D4ED8", borderRadius: 999, padding: "14px 30px", fontSize: 24, fontWeight: 800 }}>
              {t("certs.cardBadge")}
            </div>
            <div style={{ fontSize: 68, fontWeight: 900, lineHeight: 1.08, marginTop: 40 }}>{title}</div>
            <div style={{ fontSize: 34, marginTop: 40, color: "#DBEAFE" }}>{cert.holder}</div>
            <div style={{ fontSize: 26, marginTop: 14, color: "#93C5FD" }}>
              {fmt(cert.issued_at)} · {t("certs.score")} {cert.score}%
            </div>
          </div>
          <div style={{ position: "relative", display: "flex", justifyContent: "space-between", alignItems: "flex-end", fontSize: 22, color: "#93C5FD" }}>
            <span>{`ID ${cert.code}`}</span>
            <span style={{ fontWeight: 800, color: "#fff" }}>#SportScienceAcademy</span>
          </div>
        </div>
      </div>
    </>
  );
};
